module.exports = __webpack_public_path__ + "static/media/template-collections.a2cef57f.csv";